
function changeTimeZone(date, timeZone) {
  if (typeof date === 'string') return new Date(new Date(date).toLocaleString('en-US', {timeZone}))
  return new Date(date.toLocaleString('en-US', {timeZone}))
}

function getWeekDay(convertedDate) {
  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  return weekDays[convertedDate.getDay()]
}

function isAgentChatOpenHour() {
  const PSTTimezone = changeTimeZone(new Date(), 'America/Los_Angeles')
  const weekDate = (getWeekDay(PSTTimezone))
  const currentPSTHours = PSTTimezone.getHours()
  const agentAvailableTime = {
    'Sunday': {openTime: 6, closeTime: 19},'Monday': {openTime: 6, closeTime: 19},'Tuesday': {openTime: 6, closeTime: 19},'Wednesday': {openTime: 6, closeTime: 19},'Thursday': {openTime: 6, closeTime: 19},'Friday': {openTime: 6, closeTime: 19},'Saturday': {openTime: 6, closeTime: 19}
  }
  const theDay = agentAvailableTime[weekDate]
  return currentPSTHours >= theDay.openTime && currentPSTHours < theDay.closeTime
}

function chatClicked (event) {
  event.preventDefault()
  const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.outerHeight || 0)
  const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  const desiredWidth = 380
  const desiredHeight = viewportHeight
  const leftPosition = viewportWidth - desiredWidth
  window.open(
    'https://widgets.credolive.credobeauty.com/stores/credo/services/landing_page/components/landing?from=sidebar&media=desktop','credobeauty',`toolbars=0,width=${desiredWidth},height=${desiredHeight},left=${leftPosition},top=0,scrollbars=1,resizable=1`
  )
}

function turnChatUnavailable(chatWrapperGroups) {
  chatWrapperGroups.forEach(chatWrapperEl => {
    const unavailableTooltip = document.querySelector('#chat-unavailable-tooltip')
    if (unavailableTooltip) unavailableTooltip.classList.remove('disabled')
    if (chatWrapperEl) chatWrapperEl.classList.remove('active')
    if (chatWrapperEl && chatWrapperEl.getAttribute('data-header-chat-link') === 'open-widget') {
      chatWrapperEl.addEventListener('click', chatClicked)
    }
  })
}

function initHeaderChat(chatWrapperGroups) {
  if (isAgentChatOpenHour()) {
    chatWrapperGroups.forEach(chatWrapperEl => { chatWrapperEl.addEventListener('click', chatClicked) })
  } else {
    turnChatUnavailable(chatWrapperGroups)
  }
}

const headerChatWrapperGroups = document.querySelectorAll('[data-header-chat-link]')
if (headerChatWrapperGroups) {
  initHeaderChat(headerChatWrapperGroups)
}